import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t, i18n } = useTranslation('civil_statuses');
  const serviceLangsOptions = useMemo(
    () => [
      { value: 'single', label: t('single') },
      { value: 'in_relationship', label: t('in_relationship') },
      { value: 'cohabiting', label: t('cohabiting') },
      { value: 'married', label: t('married') },
      { value: 'separated', label: t('separated') },
      { value: 'divorced', label: t('divorced') },
      { value: 'widowed', label: t('widowed') },
    ],
    [i18n.language],
  );
  return { data: serviceLangsOptions };
};
